export default __webpack_public_path__ + "static/media/weibang_wbsc409h.d623b9b0.jpg";